<!-- 通知设置 -->
<template>
    <div class="notice-page">
        <!-- 一级模块 -->
        <div class="module-tabs">
            <div class="module-tab active">短信通知</div>
        </div>

        <!-- 统计卡片 -->
        <div class="stats-row">
            <div class="stat-card" v-for="item in statsList" :key="item.key">
                <div class="stat-icon">
                    <img :src="item.icon" alt="" />
                </div>
                <div class="stat-info">
                    <div class="stat-label">{{ item.label }}</div>
                    <div class="stat-value">
                        <span class="num">{{ item.value }}</span>
                        <span class="unit">{{ item.unit }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 二级导航 -->
        <div class="sub-tabs">
            <div
                v-for="tab in subTabs"
                :key="tab.key"
                :class="['sub-tab', { active: activeTab === tab.key }]"
                @click="switchTab(tab.key)"
            >
                {{ tab.label }}
            </div>
        </div>

        <!-- ==================== 通知列表 ==================== -->
        <div v-show="activeTab === 'list'" class="panel">
            <div class="filter-bar">
                <Input
                    class="filter-item w180"
                    v-model="listQuery.user_name"
                    clearable
                    placeholder="请输入用户名称"
                />
                <Input
                    class="filter-item w180"
                    v-model="listQuery.title"
                    clearable
                    placeholder="请输入标题"
                />
                <Select
                    class="filter-item w160"
                    v-model="listQuery.type"
                    clearable
                    placeholder="通知类型"
                >
                    <Option
                        v-for="item in noticeTypeOptions"
                        :key="item.value"
                        :value="item.value"
                        >{{ item.label }}</Option
                    >
                </Select>
                <DatePicker
                    class="filter-item w240"
                    type="daterange"
                    placement="bottom-end"
                    placeholder="选择时间段"
                    :value="listQuery.dateRange"
                    @on-change="onListDateChange"
                />
                <Button
                    class="theme-bc theme-default-color"
                    icon="ios-search"
                    @click="searchList"
                    >确认搜索</Button
                >
            </div>
            <Table :columns="listColumns" :data="listTable" border>
                <template slot-scope="{ row }" slot="title">
                    <div class="cell-title">{{ row.title }}</div>
                    <div class="cell-sub" v-if="row.code">溯源码: {{ row.code }}</div>
                </template>
                <template slot-scope="{ row }" slot="content">
                    <div class="cell-ellipsis" :title="row.content">{{ row.content }}</div>
                </template>
                <template slot-scope="{ row }" slot="type">
                    <span :class="['type-tag', row.type === 1 ? 'type-warn' : 'type-mass']">
                        {{ row.type_text }}
                    </span>
                </template>
                <template slot-scope="{ row }" slot="status">
                    <span :class="row.status === 1 ? 'status-ok' : 'status-fail'">
                        {{ row.status_text }}
                    </span>
                </template>
            </Table>
            <div class="page">
                <Page
                    :current="listQuery.page"
                    :page-size="listQuery.limit"
                    :total="listTotal"
                    show-elevator
                    show-total
                    @on-change="onListPageChange"
                />
            </div>
        </div>

        <!-- ==================== 用户通知 ==================== -->
        <div v-show="activeTab === 'user'" class="panel user-panel">
            <div class="switch-row">
                <span class="switch-label">消息通知开关</span>
                <i-switch
                    v-model="userConfig.enabled"
                    size="large"
                    true-color="#FF761D"
                    :true-value="1"
                    :false-value="0"
                >
                    <span slot="open">开启</span>
                    <span slot="close">关闭</span>
                </i-switch>
                <Tooltip max-width="280" placement="right" theme="light">
                    <Icon class="help-icon" type="md-help-circle" size="18" color="#FF761D" />
                    <div slot="content">
                        <p>开启后，系统将按各项配置向用户发送短信提醒。</p>
                    </div>
                </Tooltip>
                <span class="switch-tip">开启后，系统将按各项配置向用户发送短信提醒。</span>
            </div>

            <!-- 质保到期提醒 -->
            <div class="section-block">
                <div class="section-head">
                    <span class="section-title">质保到期提醒</span>
                    <span class="section-desc"
                        >默认展示，点击编辑可修改提醒时间、短信签名与模板。</span
                    >
                </div>
                <div
                    class="config-card"
                    v-for="(item, index) in userConfig.warrantyList"
                    :key="'w-' + index"
                >
                    <div class="config-card-title">第 {{ index + 1 }} 次提醒</div>
                    <div class="config-fields">
                        <div class="field-item">
                            <span class="field-label">提醒时间</span>
                            <span class="field-inline">到期前</span>
                            <Input
                                class="w80"
                                type="number"
                                v-model="item.days"
                                :disabled="!item.editing"
                            />
                            <span class="field-inline">天</span>
                        </div>
                        <div class="field-item">
                            <span class="field-label">短信签名</span>
                            <Select
                                class="w180"
                                v-model="item.sign_id"
                                :disabled="!item.editing"
                                placeholder="请选择"
                            >
                                <Option
                                    v-for="s in signOptions"
                                    :key="s.id"
                                    :value="s.id"
                                    >{{ s.name }}</Option
                                >
                            </Select>
                        </div>
                        <div class="field-item">
                            <span class="field-label">短信模板</span>
                            <Select
                                class="w220"
                                v-model="item.template_id"
                                :disabled="!item.editing"
                                placeholder="请选择"
                            >
                                <Option
                                    v-for="t in templateOptions"
                                    :key="t.id"
                                    :value="t.id"
                                    >{{ t.name }}</Option
                                >
                            </Select>
                        </div>
                        <div class="field-actions">
                            <template v-if="item.editing">
                                <a class="link-primary" @click="saveWarranty(index)">保存</a>
                            </template>
                            <template v-else>
                                <a class="link-primary" @click="editWarranty(index)">编辑</a>
                                <a class="link-danger" @click="removeWarranty(index)">删除</a>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="add-link" @click="addWarranty">
                    <Icon type="md-add" /> 添加提醒
                </div>
            </div>

            <!-- 群发提醒 -->
            <div class="section-block">
                <div class="section-head">
                    <span class="section-title">群发提醒</span>
                    <span class="section-desc"
                        >可设定群发时间，完成后可在通知列表中查看发送记录。</span
                    >
                </div>
                <div
                    class="config-card"
                    v-for="(item, index) in userConfig.massList"
                    :key="'m-' + index"
                >
                    <div class="config-fields wrap">
                        <div class="field-item">
                            <span class="field-label">群发标题</span>
                            <Input
                                class="w200"
                                v-model="item.title"
                                :disabled="!item.editing"
                                placeholder="请输入群发标题"
                            />
                        </div>
                        <div class="field-item">
                            <span class="field-label">短信签名</span>
                            <Select
                                class="w160"
                                v-model="item.sign_id"
                                :disabled="!item.editing"
                                placeholder="请选择"
                            >
                                <Option
                                    v-for="s in signOptions"
                                    :key="s.id"
                                    :value="s.id"
                                    >{{ s.name }}</Option
                                >
                            </Select>
                        </div>
                        <div class="field-item">
                            <span class="field-label">短信模板</span>
                            <Select
                                class="w200"
                                v-model="item.template_id"
                                :disabled="!item.editing"
                                placeholder="请选择"
                            >
                                <Option
                                    v-for="t in templateOptions"
                                    :key="t.id"
                                    :value="t.id"
                                    >{{ t.name }}</Option
                                >
                            </Select>
                        </div>
                        <div class="field-item">
                            <span class="field-label">群发时间</span>
                            <DatePicker
                                class="w200"
                                type="datetime"
                                :value="item.send_time"
                                :disabled="!item.editing"
                                placeholder="请选择时间"
                                @on-change="(v) => (item.send_time = v)"
                            />
                        </div>
                        <div class="field-item field-people">
                            <span class="field-label">群发人员</span>
                            <div class="people-box" :class="{ disabled: !item.editing }">
                                <Tag
                                    v-for="(p, pi) in item.people"
                                    :key="pi"
                                    color="orange"
                                    :closable="item.editing"
                                    @on-close="removePeople(index, pi)"
                                    >{{ p.name }}</Tag
                                >
                                <span
                                    v-if="item.editing"
                                    class="people-add"
                                    @click="openPeoplePicker(index)"
                                    >+ 选择人员</span
                                >
                            </div>
                        </div>
                        <div class="field-actions">
                            <template v-if="item.editing">
                                <a class="link-primary" @click="saveMass(index)">保存</a>
                            </template>
                            <template v-else>
                                <a class="link-primary" @click="editMass(index)">编辑</a>
                                <a class="link-danger" @click="removeMass(index)">删除</a>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="add-link" @click="addMass">
                    <Icon type="md-add" /> 添加群发
                </div>
            </div>

            <div class="footer-actions">
                <Button @click="cancelUserConfig">取消</Button>
                <Button class="theme-bc theme-default-color ml12" @click="submitUserConfig"
                    >确定</Button
                >
            </div>
        </div>

        <!-- ==================== 短信购买 ==================== -->
        <div v-show="activeTab === 'purchase'" class="panel">
            <div class="section-title mb16">推荐套餐</div>
            <div class="package-row">
                <div
                    v-for="item in packageList"
                    :key="item.id"
                    :class="['package-card', { active: selectedPackage === item.id }]"
                    @click="selectedPackage = item.id"
                >
                    <div class="pkg-name">{{ item.name }}</div>
                    <div class="pkg-count">
                        <span class="pkg-num">{{ item.count }}</span>
                        <span class="pkg-unit">条</span>
                    </div>
                    <div class="pkg-price">¥ {{ item.price }}</div>
                </div>
            </div>
            <div class="purchase-bar">
                <div class="purchase-info">
                    <div class="purchase-main">
                        已选
                        <span class="hl">{{ currentPackage.name }}</span
                        >，到账
                        <span class="hl">{{ currentPackage.count }}</span> 条
                    </div>
                    <div class="purchase-tip">确认购买即表示同意短信服务购买规则。</div>
                </div>
                <Button
                    class="theme-bc theme-default-color purchase-btn"
                    @click="openPayModal"
                >
                    确认购买 ¥{{ currentPackage.price }}
                </Button>
            </div>
        </div>

        <!-- ==================== 短信模板 ==================== -->
        <div v-show="activeTab === 'template'" class="panel">
            <div class="filter-bar">
                <Input
                    class="filter-item w260"
                    v-model="tplQuery.keyword"
                    clearable
                    placeholder="请输入未通过原因、文本内容"
                />
                <Select
                    class="filter-item w160"
                    v-model="tplQuery.status"
                    clearable
                    placeholder="模板状态"
                >
                    <Option
                        v-for="item in auditStatusOptions"
                        :key="item.value"
                        :value="item.value"
                        >{{ item.label }}</Option
                    >
                </Select>
                <DatePicker
                    class="filter-item w240"
                    type="daterange"
                    placeholder="选择时间段"
                    :value="tplQuery.dateRange"
                    @on-change="(v) => (tplQuery.dateRange = v)"
                />
                <Button
                    class="theme-bc theme-default-color"
                    icon="ios-search"
                    @click="searchTemplate"
                    >确认搜索</Button
                >
            </div>
            <div class="action-bar">
                <Button
                    class="theme-bc theme-default-color"
                    icon="md-add"
                    @click="openTplModal"
                    >新增短信模板</Button
                >
                <span class="price-tip">短信模板：¥ 0.01/1次</span>
            </div>
            <Table :columns="tplColumns" :data="tplTable" border>
                <template slot-scope="{ row }" slot="content">
                    <div class="cell-ellipsis" :title="row.content">{{ row.content }}</div>
                </template>
                <template slot-scope="{ row }" slot="status">
                    <span :class="'audit-' + row.status">{{ row.status_text }}</span>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button
                            v-if="row.status === 3"
                            type="primary"
                            ghost
                            size="small"
                            @click="openPayModal(row)"
                            >支付</Button
                        >
                        <Button type="error" ghost size="small" @click="deleteTemplate(row)"
                            >删除</Button
                        >
                    </div>
                </template>
            </Table>
            <div class="page">
                <Page
                    :current="tplQuery.page"
                    :page-size="tplQuery.limit"
                    :total="tplTotal"
                    show-elevator
                    show-total
                    @on-change="(p) => ((tplQuery.page = p), searchTemplate())"
                />
            </div>
        </div>

        <!-- ==================== 短信签名 ==================== -->
        <div v-show="activeTab === 'sign'" class="panel">
            <div class="filter-bar">
                <Input
                    class="filter-item w260"
                    v-model="signQuery.keyword"
                    clearable
                    placeholder="请输入未通过原因、文本内容"
                />
                <Select
                    class="filter-item w160"
                    v-model="signQuery.status"
                    clearable
                    placeholder="模板状态"
                >
                    <Option
                        v-for="item in auditStatusOptions"
                        :key="item.value"
                        :value="item.value"
                        >{{ item.label }}</Option
                    >
                </Select>
                <DatePicker
                    class="filter-item w240"
                    type="daterange"
                    placeholder="选择时间段"
                    :value="signQuery.dateRange"
                    @on-change="(v) => (signQuery.dateRange = v)"
                />
                <Button
                    class="theme-bc theme-default-color"
                    icon="ios-search"
                    @click="searchSign"
                    >确认搜索</Button
                >
            </div>
            <div class="action-bar">
                <Button
                    class="theme-bc theme-default-color"
                    icon="md-add"
                    @click="openSignModal"
                    >新增短信签名</Button
                >
                <span class="price-tip">短信签名：¥ 0.01/1次</span>
            </div>
            <Table :columns="signColumns" :data="signTable" border>
                <template slot-scope="{ row }" slot="status">
                    <span :class="'audit-' + row.status">{{ row.status_text }}</span>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button
                            v-if="row.status === 3"
                            type="primary"
                            ghost
                            size="small"
                            @click="openPayModal(row)"
                            >支付</Button
                        >
                        <Button
                            v-if="row.status === 1"
                            type="primary"
                            ghost
                            size="small"
                            @click="approveSign(row)"
                            >通过</Button
                        >
                        <Button
                            v-if="row.status === 1"
                            type="error"
                            ghost
                            size="small"
                            @click="rejectSign(row)"
                            >拒绝</Button
                        >
                        <Button type="error" ghost size="small" @click="deleteSign(row)"
                            >删除</Button
                        >
                    </div>
                </template>
            </Table>
            <div class="page">
                <Page
                    :current="signQuery.page"
                    :page-size="signQuery.limit"
                    :total="signTotal"
                    show-elevator
                    show-total
                    @on-change="(p) => ((signQuery.page = p), searchSign())"
                />
            </div>
        </div>

        <!-- 支付弹窗 -->
        <Modal v-model="payModal" title="支付" width="480" :mask-closable="false">
            <div class="pay-body">
                <div class="pay-qrcode">
                    <div class="qrcode-placeholder">
                        <Icon type="md-qr-scanner" size="48" color="#C5C8D2" />
                        <p>扫码支付</p>
                    </div>
                </div>
                <div class="pay-amount">
                    <div class="pay-label">应支付金额</div>
                    <div class="pay-price">¥{{ payInfo.price }}</div>
                    <div class="pay-origin" v-if="payInfo.origin">
                        原价¥{{ payInfo.origin }}
                    </div>
                </div>
            </div>
            <div slot="footer">
                <Button @click="payModal = false">关闭</Button>
            </div>
        </Modal>

        <!-- 新增短信模板 -->
        <Modal
            v-model="tplModal"
            title="新增短信模板"
            width="560"
            :mask-closable="false"
        >
            <Form :label-width="100" label-position="right">
                <FormItem label="模板内容:">
                    <Input
                        type="textarea"
                        v-model="tplForm.content"
                        :maxlength="30"
                        :rows="5"
                        show-word-limit
                        placeholder="请输入模板内容"
                    />
                    <div class="word-count">{{ (tplForm.content || '').length }}/30</div>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="tplModal = false">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitTpl">确认</Button>
            </div>
        </Modal>

        <!-- 新增短信签名 -->
        <Modal
            v-model="signModal"
            title="新增短信签名"
            width="520"
            :mask-closable="false"
        >
            <Form :label-width="100" label-position="right">
                <FormItem label="短信签名:">
                    <Input
                        type="textarea"
                        v-model="signForm.name"
                        :maxlength="10"
                        :rows="4"
                        placeholder="请输入短信签名"
                    />
                    <div class="word-count">{{ (signForm.name || '').length }}/10</div>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="signModal = false">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitSign">确认</Button>
            </div>
        </Modal>

        <!-- 群发人员选择 -->
        <Modal
            v-model="peopleModal"
            title="选择群发人员"
            width="520"
            :mask-closable="false"
        >
            <div class="people-picker">
                <div class="people-tabs">
                    <span
                        v-for="t in peopleTabs"
                        :key="t.key"
                        :class="['ptab', { active: peopleTab === t.key }]"
                        @click="peopleTab = t.key"
                        >{{ t.label }}</span
                    >
                </div>
                <Input
                    class="mb12"
                    v-model="peopleKeyword"
                    search
                    placeholder="搜索人员/标签"
                />
                <div class="people-list">
                    <CheckboxGroup v-model="peopleChecked">
                        <div
                            class="people-item"
                            v-for="p in filteredPeople"
                            :key="p.id"
                        >
                            <Checkbox :label="p.id">
                                <span>{{ p.name }}</span>
                                <span class="people-phone" v-if="p.mobile">{{ p.mobile }}</span>
                            </Checkbox>
                        </div>
                    </CheckboxGroup>
                </div>
            </div>
            <div slot="footer">
                <Button @click="peopleModal = false">取消</Button>
                <Button class="theme-bc theme-default-color" @click="confirmPeople"
                    >确定</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import iconSmsSent from '@/assets/system/sms-sent.png';
import iconSmsBalance from '@/assets/system/sms-balance.png';
import iconSuccessRate from '@/assets/system/success-rate.png';
import iconActiveTemplates from '@/assets/system/active-templates.png';
// 预留后端接口（对接后取消注释并替换静态数据）
// import {
//     system_notice_stats,
//     system_notice_list,
//     system_notice_user_config,
//     system_notice_user_save,
//     system_notice_package_list,
//     system_notice_package_buy,
//     system_notice_template_list,
//     system_notice_template_save,
//     system_notice_template_delete,
//     system_notice_sign_list,
//     system_notice_sign_save,
//     system_notice_sign_delete,
//     system_notice_pay_qrcode,
// } from '@/api/notice';

const AUDIT_MAP = {
    1: '待审核',
    2: '审核通过',
    3: '待付款',
    4: '审核失败',
};

export default {
    name: 'SystemNotification',
    data() {
        return {
            activeTab: 'list',
            subTabs: [
                { key: 'list', label: '通知列表' },
                { key: 'user', label: '用户通知' },
                { key: 'purchase', label: '短信购买' },
                { key: 'template', label: '短信模板' },
                { key: 'sign', label: '短信签名' },
            ],
            statsList: [
                {
                    key: 'sent',
                    label: '本月短信发送',
                    value: '1234',
                    unit: '条',
                    icon: iconSmsSent,
                },
                {
                    key: 'balance',
                    label: '短信剩余条数',
                    value: '1234',
                    unit: '条',
                    icon: iconSmsBalance,
                },
                {
                    key: 'rate',
                    label: '发送成功率',
                    value: '99.2',
                    unit: '%',
                    icon: iconSuccessRate,
                },
                {
                    key: 'tpl',
                    label: '启用中模板',
                    value: '12',
                    unit: '个',
                    icon: iconActiveTemplates,
                },
            ],
            noticeTypeOptions: [
                { value: 1, label: '质保到期提醒' },
                { value: 2, label: '群发提醒' },
            ],
            auditStatusOptions: [
                { value: 1, label: '待审核' },
                { value: 2, label: '审核通过' },
                { value: 3, label: '待付款' },
                { value: 4, label: '审核失败' },
            ],
            signOptions: [
                { id: 1, name: '云溯源' },
                { id: 2, name: '品牌官方' },
            ],
            templateOptions: [
                { id: 1, name: '质保到期提醒模板' },
                { id: 2, name: '群发活动模板' },
            ],
            // 通知列表
            listQuery: {
                user_name: '',
                title: '',
                type: '',
                dateRange: [],
                page: 1,
                limit: 10,
            },
            listTotal: 999,
            listColumns: [
                { title: '#', type: 'index', width: 60, align: 'center' },
                { title: '标题', slot: 'title', minWidth: 180 },
                { title: '通知内容', slot: 'content', minWidth: 220 },
                { title: '通知类型', slot: 'type', width: 130, align: 'center' },
                { title: '接收用户', key: 'user_name', width: 100, align: 'center' },
                { title: '手机号', key: 'mobile', width: 130, align: 'center' },
                { title: '发送状态', slot: 'status', width: 100, align: 'center' },
                { title: '发送时间', key: 'send_time', width: 160, align: 'center' },
            ],
            listTable: [
                {
                    title: '臻选养生壶',
                    code: 'TR20260828001',
                    content: '[云溯源] 您购买的臻选养生壶质保即将到期，请及时关注。',
                    type: 1,
                    type_text: '质保到期提醒',
                    user_name: '张先生',
                    mobile: '138****2864',
                    status: 1,
                    status_text: '发送成功',
                    send_time: '2026-08-28 10:18',
                },
                {
                    title: '春季保养活动',
                    code: '',
                    content: '[云溯源] 春季保养限时活动开启，欢迎参与领取专属福利。',
                    type: 2,
                    type_text: '群发提醒',
                    user_name: '李女士',
                    mobile: '139****5521',
                    status: 0,
                    status_text: '发送失败',
                    send_time: '2026-08-27 16:42',
                },
                {
                    title: '智能净水器',
                    code: 'TR20260825088',
                    content: '[云溯源] 您购买的智能净水器质保将于30天后到期。',
                    type: 1,
                    type_text: '质保到期提醒',
                    user_name: '王先生',
                    mobile: '186****9033',
                    status: 1,
                    status_text: '发送成功',
                    send_time: '2026-08-26 09:05',
                },
            ],
            // 用户通知
            userConfig: {
                enabled: 1,
                warrantyList: [
                    {
                        days: 30,
                        sign_id: 1,
                        template_id: 1,
                        editing: false,
                    },
                    {
                        days: 7,
                        sign_id: 1,
                        template_id: 1,
                        editing: true,
                    },
                ],
                massList: [
                    {
                        title: '新品上市通知',
                        sign_id: 1,
                        template_id: 2,
                        send_time: '2026-09-10 10:00:00',
                        people: [
                            { id: 'tag-1', name: '标签名称*120人' },
                            { id: 2, name: '人员名称' },
                        ],
                        editing: false,
                    },
                ],
            },
            peopleModal: false,
            peopleTab: 'all',
            peopleTabs: [
                { key: 'all', label: '全部' },
                { key: 'tag', label: '人员标签' },
                { key: 'person', label: '具体人员' },
            ],
            peopleKeyword: '',
            peopleChecked: [],
            peopleEditIndex: -1,
            peoplePool: [
                { id: 1, name: '张先生', mobile: '138****2864', type: 'person' },
                { id: 2, name: '李女士', mobile: '139****5521', type: 'person' },
                { id: 3, name: '王先生', mobile: '186****9033', type: 'person' },
                { id: 'tag-1', name: '标签名称*120人', mobile: '', type: 'tag' },
                { id: 'tag-2', name: 'VIP客户*56人', mobile: '', type: 'tag' },
            ],
            // 短信购买
            selectedPackage: 1,
            packageList: [
                { id: 1, name: '基础包', count: 400, price: 100, origin: 120 },
                { id: 2, name: '畅享包', count: 2000, price: 200, origin: 260 },
                { id: 3, name: '企业包', count: 6000, price: 500, origin: 580 },
            ],
            // 模板
            tplQuery: { keyword: '', status: '', dateRange: [], page: 1, limit: 10 },
            tplTotal: 999,
            tplColumns: [
                { title: '#', type: 'index', width: 60, align: 'center' },
                { title: '文本说明', slot: 'content', minWidth: 240 },
                { title: '模板状态', slot: 'status', width: 110, align: 'center' },
                { title: '未通过原因', key: 'reason', width: 160, align: 'center' },
                { title: '申请时间', key: 'created_at', width: 160, align: 'center' },
                { title: '操作', slot: 'operate', width: 160, align: 'center' },
            ],
            tplTable: [
                {
                    id: 1,
                    content: '您购买的商品质保即将到期，请及时关注售后服务。',
                    status: 3,
                    status_text: '待付款',
                    reason: '--',
                    created_at: '2026-08-28 10:18',
                },
                {
                    id: 2,
                    content: '尊敬的用户，您的产品已完成质检，欢迎扫码查验。',
                    status: 1,
                    status_text: '待审核',
                    reason: '--',
                    created_at: '2026-08-27 15:20',
                },
                {
                    id: 3,
                    content: '活动通知：限时福利已开启，详情请查看小程序。',
                    status: 2,
                    status_text: '审核通过',
                    reason: '--',
                    created_at: '2026-08-26 09:12',
                },
                {
                    id: 4,
                    content: '您好，您的验证码是******，请勿泄露。',
                    status: 4,
                    status_text: '审核失败',
                    reason: '内容涉及敏感信息',
                    created_at: '2026-08-25 11:06',
                },
            ],
            tplModal: false,
            tplForm: { content: '' },
            // 签名
            signQuery: { keyword: '', status: '', dateRange: [], page: 1, limit: 10 },
            signTotal: 999,
            signColumns: [
                { title: '#', type: 'index', width: 60, align: 'center' },
                { title: '签名名称', key: 'name', minWidth: 160 },
                { title: '签名状态', slot: 'status', width: 110, align: 'center' },
                { title: '未通过原因', key: 'reason', width: 160, align: 'center' },
                { title: '申请时间', key: 'created_at', width: 160, align: 'center' },
                { title: '操作', slot: 'operate', width: 200, align: 'center' },
            ],
            signTable: [
                {
                    id: 1,
                    name: '云溯源',
                    status: 2,
                    status_text: '审核通过',
                    reason: '--',
                    created_at: '2026-08-28 10:18',
                },
                {
                    id: 2,
                    name: '品牌官方',
                    status: 3,
                    status_text: '待付款',
                    reason: '--',
                    created_at: '2026-08-27 14:22',
                },
                {
                    id: 3,
                    name: '新品系列',
                    status: 1,
                    status_text: '待审核',
                    reason: '--',
                    created_at: '2026-08-26 09:40',
                },
                {
                    id: 4,
                    name: '测试签名',
                    status: 4,
                    status_text: '审核失败',
                    reason: '签名不符合规范',
                    created_at: '2026-08-25 16:08',
                },
            ],
            signModal: false,
            signForm: { name: '' },
            // 支付
            payModal: false,
            payInfo: { price: '100.00', origin: '' },
        };
    },
    computed: {
        currentPackage() {
            return (
                this.packageList.find((p) => p.id === this.selectedPackage) ||
                this.packageList[0]
            );
        },
        filteredPeople() {
            let list = this.peoplePool;
            if (this.peopleTab === 'tag') {
                list = list.filter((p) => p.type === 'tag');
            } else if (this.peopleTab === 'person') {
                list = list.filter((p) => p.type === 'person');
            }
            if (this.peopleKeyword) {
                const kw = this.peopleKeyword.trim();
                list = list.filter(
                    (p) =>
                        (p.name && p.name.indexOf(kw) > -1) ||
                        (p.mobile && p.mobile.indexOf(kw) > -1)
                );
            }
            return list;
        },
    },
    mounted() {
        this.initPage();
    },
    methods: {
        // 初始化（对接后在此调用统计/列表接口）
        initPage() {
            // system_notice_stats().then(res => { ... }).catch(...)
            // this.searchList();
        },
        switchTab(key) {
            this.activeTab = key;
        },
        onListDateChange(val) {
            this.listQuery.dateRange = val;
        },
        searchList() {
            // system_notice_list(this.listQuery).then(...).catch(...)
            this.$Message.success('搜索完成（静态演示）');
        },
        onListPageChange(page) {
            this.listQuery.page = page;
            this.searchList();
        },
        // ---- 用户通知 ----
        editWarranty(index) {
            this.$set(this.userConfig.warrantyList[index], 'editing', true);
        },
        saveWarranty(index) {
            this.$set(this.userConfig.warrantyList[index], 'editing', false);
            this.$Message.success('已保存');
        },
        removeWarranty(index) {
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除该提醒吗？',
                onOk: () => {
                    this.userConfig.warrantyList.splice(index, 1);
                },
            });
        },
        addWarranty() {
            this.userConfig.warrantyList.push({
                days: 30,
                sign_id: '',
                template_id: '',
                editing: true,
            });
        },
        editMass(index) {
            this.$set(this.userConfig.massList[index], 'editing', true);
        },
        saveMass(index) {
            this.$set(this.userConfig.massList[index], 'editing', false);
            this.$Message.success('已保存');
        },
        removeMass(index) {
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除该群发吗？',
                onOk: () => {
                    this.userConfig.massList.splice(index, 1);
                },
            });
        },
        addMass() {
            this.userConfig.massList.push({
                title: '',
                sign_id: '',
                template_id: '',
                send_time: '',
                people: [],
                editing: true,
            });
        },
        removePeople(massIndex, peopleIndex) {
            this.userConfig.massList[massIndex].people.splice(peopleIndex, 1);
        },
        openPeoplePicker(index) {
            this.peopleEditIndex = index;
            const current = this.userConfig.massList[index].people || [];
            this.peopleChecked = current.map((p) => p.id);
            this.peopleKeyword = '';
            this.peopleTab = 'all';
            this.peopleModal = true;
        },
        confirmPeople() {
            const selected = this.peoplePool.filter((p) =>
                this.peopleChecked.includes(p.id)
            );
            this.$set(
                this.userConfig.massList[this.peopleEditIndex],
                'people',
                selected.map((p) => ({ id: p.id, name: p.name }))
            );
            this.peopleModal = false;
        },
        cancelUserConfig() {
            this.$Message.info('已取消');
        },
        submitUserConfig() {
            // system_notice_user_save(this.userConfig).then(...).catch(...)
            this.$Message.success('保存成功（静态演示）');
        },
        // ---- 购买 / 支付 ----
        openPayModal(row) {
            if (row && row.price) {
                this.payInfo = {
                    price: Number(row.price).toFixed(2),
                    origin: row.origin ? Number(row.origin).toFixed(2) : '',
                };
            } else if (this.activeTab === 'purchase') {
                const pkg = this.currentPackage;
                this.payInfo = {
                    price: Number(pkg.price).toFixed(2),
                    origin: pkg.origin ? Number(pkg.origin).toFixed(2) : '',
                };
            } else {
                this.payInfo = { price: '0.01', origin: '' };
            }
            // system_notice_pay_qrcode(...).then(...)
            this.payModal = true;
        },
        // ---- 模板 ----
        searchTemplate() {
            // system_notice_template_list(this.tplQuery).then(...).catch(...)
            this.$Message.success('搜索完成（静态演示）');
        },
        openTplModal() {
            this.tplForm = { content: '' };
            this.tplModal = true;
        },
        submitTpl() {
            if (!this.tplForm.content || !this.tplForm.content.trim()) {
                this.$Message.warning('请输入模板内容');
                return;
            }
            // system_notice_template_save(this.tplForm).then(...).catch(...)
            this.tplTable.unshift({
                id: Date.now(),
                content: this.tplForm.content.trim(),
                status: 3,
                status_text: AUDIT_MAP[3],
                reason: '--',
                created_at: this.formatNow(),
            });
            this.tplModal = false;
            this.$Message.success('提交成功（静态演示）');
        },
        deleteTemplate(row) {
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除该模板吗？一经删除无法复原',
                onOk: () => {
                    // system_notice_template_delete({ id: row.id })
                    const idx = this.tplTable.findIndex((i) => i.id === row.id);
                    if (idx > -1) this.tplTable.splice(idx, 1);
                    this.$Message.success('删除成功');
                },
            });
        },
        // ---- 签名 ----
        searchSign() {
            // system_notice_sign_list(this.signQuery).then(...).catch(...)
            this.$Message.success('搜索完成（静态演示）');
        },
        openSignModal() {
            this.signForm = { name: '' };
            this.signModal = true;
        },
        submitSign() {
            if (!this.signForm.name || !this.signForm.name.trim()) {
                this.$Message.warning('请输入短信签名');
                return;
            }
            // system_notice_sign_save(this.signForm).then(...).catch(...)
            this.signTable.unshift({
                id: Date.now(),
                name: this.signForm.name.trim(),
                status: 3,
                status_text: AUDIT_MAP[3],
                reason: '--',
                created_at: this.formatNow(),
            });
            this.signModal = false;
            this.$Message.success('提交成功（静态演示）');
        },
        deleteSign(row) {
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除该签名吗？一经删除无法复原',
                onOk: () => {
                    // system_notice_sign_delete({ id: row.id })
                    const idx = this.signTable.findIndex((i) => i.id === row.id);
                    if (idx > -1) this.signTable.splice(idx, 1);
                    this.$Message.success('删除成功');
                },
            });
        },
        approveSign() {
            this.$Message.success('已通过（静态演示）');
        },
        rejectSign() {
            this.$Message.warning('已拒绝（静态演示）');
        },
        formatNow() {
            const d = new Date();
            const p = (n) => (n < 10 ? '0' + n : '' + n);
            return (
                d.getFullYear() +
                '-' +
                p(d.getMonth() + 1) +
                '-' +
                p(d.getDate()) +
                ' ' +
                p(d.getHours()) +
                ':' +
                p(d.getMinutes())
            );
        },
    },
};
</script>

<style scoped>
.notice-page {
    padding: 20px 24px 28px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    min-height: calc(100vh - 140px);
}

/* 一级模块 Tab */
.module-tabs {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    border-bottom: 1px solid #eef0f5;
}
.module-tab {
    position: relative;
    padding: 10px 22px;
    margin-bottom: -1px;
    font-size: 14px;
    color: #8a91a8;
    cursor: pointer;
    border: 1px solid transparent;
    border-radius: 6px 6px 0 0;
    transition: all 0.2s;
}
.module-tab.active {
    color: #ff761d;
    font-weight: 600;
    background: #fff7f0;
    border-color: #ffd0a8;
    border-bottom-color: #ffffff;
}
.module-tab.active::after {
    content: '';
    position: absolute;
    left: 18px;
    right: 18px;
    bottom: 0;
    height: 2px;
    background: #ff761d;
    border-radius: 1px;
}

/* 统计卡片 */
.stats-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 24px;
}
.stat-card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 18px 20px;
    background: #ffffff;
    border: 1px solid #eef0f5;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(82, 102, 136, 0.04);
    transition: box-shadow 0.2s, transform 0.2s;
}
.stat-card:hover {
    box-shadow: 0 6px 16px rgba(82, 102, 136, 0.1);
    transform: translateY(-1px);
}
.stat-icon {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.stat-icon img {
    width: 48px;
    height: 48px;
    object-fit: contain;
    display: block;
    border-radius: 10px;
}
.stat-label {
    font-size: 13px;
    color: #8a91a8;
    line-height: 1.4;
    margin-bottom: 6px;
}
.stat-value .num {
    font-size: 26px;
    font-weight: 700;
    color: #2f3447;
    letter-spacing: -0.5px;
    line-height: 1.1;
}
.stat-value .unit {
    margin-left: 4px;
    font-size: 13px;
    color: #8a91a8;
}

/* 二级导航 */
.sub-tabs {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
    border-bottom: 1px solid #eef0f5;
}
.sub-tab {
    position: relative;
    padding: 12px 18px;
    font-size: 14px;
    color: #6b7285;
    cursor: pointer;
    transition: color 0.2s;
    user-select: none;
}
.sub-tab:hover {
    color: #ff761d;
}
.sub-tab.active {
    color: #ff761d;
    font-weight: 600;
}
.sub-tab.active::after {
    content: '';
    position: absolute;
    left: 14px;
    right: 14px;
    bottom: -1px;
    height: 2px;
    background: #ff761d;
    border-radius: 1px;
}

.panel {
    min-height: 320px;
}

/* 筛选栏 */
.filter-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
}
.filter-item {
    flex-shrink: 0;
}
.w80 {
    width: 80px !important;
}
.w160 {
    width: 160px !important;
}
.w180 {
    width: 180px !important;
}
.w200 {
    width: 200px !important;
}
.w220 {
    width: 220px !important;
}
.w240 {
    width: 240px !important;
}
.w260 {
    width: 260px !important;
}

.action-bar {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 16px;
}
.price-tip {
    font-size: 13px;
    color: #9aa1b5;
}

.page {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}

.cell-title {
    color: #2f3447;
    font-weight: 500;
}
.cell-sub {
    margin-top: 2px;
    font-size: 12px;
    color: #9aa1b5;
}
.cell-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.5;
    color: #484e66;
}

.type-tag {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 20px;
}
.type-warn {
    color: #ff761d;
    background: #fff4e8;
}
.type-mass {
    color: #19be6b;
    background: #e8f9f0;
}
.status-ok {
    color: #19be6b;
    font-weight: 500;
}
.status-fail {
    color: #ed4014;
    font-weight: 500;
}
.audit-1 {
    color: #ff761d;
}
.audit-2 {
    color: #19be6b;
}
.audit-3 {
    color: #2d8cf0;
}
.audit-4 {
    color: #ed4014;
}

/* 用户通知 */
.user-panel {
    padding-bottom: 8px;
}
.switch-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 28px;
    padding: 16px 18px;
    background: #fafbfc;
    border-radius: 8px;
    border: 1px solid #eef0f5;
}
.switch-label {
    font-size: 14px;
    font-weight: 600;
    color: #2f3447;
}
.help-icon {
    cursor: pointer;
}
.switch-tip {
    font-size: 13px;
    color: #9aa1b5;
}

.section-block {
    margin-bottom: 28px;
}
.section-head {
    display: flex;
    align-items: baseline;
    gap: 12px;
    margin-bottom: 14px;
}
.section-title {
    font-size: 15px;
    font-weight: 600;
    color: #2f3447;
}
.section-desc {
    font-size: 12px;
    color: #9aa1b5;
}
.mb16 {
    margin-bottom: 16px;
}

.config-card {
    padding: 16px 18px;
    margin-bottom: 12px;
    background: #ffffff;
    border: 1px solid #eef0f5;
    border-radius: 8px;
    transition: border-color 0.2s;
}
.config-card:hover {
    border-color: #ffd0a8;
}
.config-card-title {
    margin-bottom: 12px;
    font-size: 13px;
    font-weight: 600;
    color: #ff761d;
}
.config-fields {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 20px;
}
.field-item {
    display: flex;
    align-items: center;
    gap: 8px;
}
.field-label {
    flex-shrink: 0;
    font-size: 13px;
    color: #6b7285;
}
.field-inline {
    font-size: 13px;
    color: #6b7285;
}
.field-people {
    flex: 1 1 100%;
}
.field-actions {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 14px;
}
.link-primary {
    color: #ff761d;
    cursor: pointer;
    font-size: 13px;
}
.link-primary:hover {
    opacity: 0.85;
}
.link-danger {
    color: #ed4014;
    cursor: pointer;
    font-size: 13px;
}
.link-danger:hover {
    opacity: 0.85;
}

.people-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    min-height: 36px;
    padding: 6px 10px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    background: #fff;
    min-width: 280px;
    flex: 1;
}
.people-box.disabled {
    background: #f7f8fa;
}
.people-add {
    color: #ff761d;
    font-size: 13px;
    cursor: pointer;
}

.add-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 4px;
    color: #ff761d;
    font-size: 14px;
    cursor: pointer;
    user-select: none;
}
.add-link:hover {
    opacity: 0.85;
}

.footer-actions {
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
    margin-top: 8px;
    border-top: 1px solid #eef0f5;
}

/* 套餐购买 */
.package-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-bottom: 24px;
}
.package-card {
    padding: 28px 20px;
    text-align: center;
    border: 1px solid #e6e8ef;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s;
    background: #fff;
}
.package-card:hover {
    border-color: #ffb26b;
    box-shadow: 0 6px 18px rgba(255, 118, 29, 0.08);
}
.package-card.active {
    border-color: #ff761d;
    background: linear-gradient(180deg, #fffaf5 0%, #ffffff 100%);
    box-shadow: 0 8px 20px rgba(255, 118, 29, 0.12);
}
.pkg-name {
    font-size: 14px;
    color: #6b7285;
    margin-bottom: 16px;
}
.pkg-count {
    margin-bottom: 18px;
}
.pkg-num {
    font-size: 36px;
    font-weight: 700;
    color: #2f3447;
    letter-spacing: -1px;
}
.pkg-unit {
    margin-left: 4px;
    font-size: 14px;
    color: #8a91a8;
}
.pkg-price {
    font-size: 20px;
    font-weight: 600;
    color: #ff761d;
}

.purchase-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 18px 22px;
    background: #f7f8fa;
    border: 1px solid #eef0f5;
    border-radius: 10px;
}
.purchase-main {
    font-size: 15px;
    color: #2f3447;
    margin-bottom: 6px;
}
.purchase-main .hl {
    color: #ff761d;
    font-weight: 700;
}
.purchase-tip {
    font-size: 12px;
    color: #9aa1b5;
}
.purchase-btn {
    flex-shrink: 0;
    min-width: 160px;
    height: 40px;
    font-size: 15px;
    border-radius: 6px;
}

/* 支付弹窗 */
.pay-body {
    display: flex;
    align-items: center;
    gap: 32px;
    padding: 12px 8px 4px;
}
.pay-qrcode {
    flex-shrink: 0;
}
.qrcode-placeholder {
    width: 180px;
    height: 180px;
    border: 1px dashed #d8dbe5;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #9aa1b5;
    background: #fafbfc;
}
.qrcode-placeholder p {
    margin-top: 8px;
    font-size: 13px;
}
.pay-label {
    font-size: 13px;
    color: #8a91a8;
    margin-bottom: 10px;
}
.pay-price {
    font-size: 32px;
    font-weight: 700;
    color: #ed4014;
    line-height: 1.2;
}
.pay-origin {
    margin-top: 8px;
    font-size: 13px;
    color: #9aa1b5;
    text-decoration: line-through;
}

.word-count {
    margin-top: 6px;
    text-align: right;
    font-size: 12px;
    color: #9aa1b5;
}

/* 人员选择 */
.people-picker .people-tabs {
    display: flex;
    gap: 4px;
    margin-bottom: 12px;
    border-bottom: 1px solid #eef0f5;
}
.ptab {
    padding: 8px 14px;
    font-size: 13px;
    color: #6b7285;
    cursor: pointer;
}
.ptab.active {
    color: #ff761d;
    font-weight: 600;
    border-bottom: 2px solid #ff761d;
}
.people-list {
    max-height: 280px;
    overflow-y: auto;
    border: 1px solid #eef0f5;
    border-radius: 6px;
    padding: 6px 0;
}
.people-item {
    padding: 8px 14px;
}
.people-item:hover {
    background: #fafbfc;
}
.people-phone {
    margin-left: 10px;
    color: #9aa1b5;
    font-size: 12px;
}

@media (max-width: 1280px) {
    .stats-row {
        grid-template-columns: repeat(2, 1fr);
    }
    .package-row {
        grid-template-columns: 1fr;
    }
}
</style>
